<template>
  <!-- Phase 2 - SBI Payment Gateway enabled with dynamic fee (#22) -->
  <expandable header="Payment Details">
    <div class="d-flex align-items-center">
      <div>
        <h6 class="mb-0">Annual Registration Fee (ARF): ₹{{ feeAmount }}</h6>
        <small class="text-muted">Payment via SBI ePay Gateway</small>
      </div>
      <div class="flex-grow-1"></div>
      <b-badge v-if="isPaid" variant="success" class="mr-2 p-2">Paid</b-badge>
      <b-button
        v-if="!isPaid"
        variant="primary"
        :disabled="isDisabled"
        @click="paynow"
        >Pay Now</b-button
      >
    </div>
  </expandable>
</template>

<script>
import hospitalService from "../../../assets/services/hospital.service";
import { FEE_AMOUNTS, PAYMENT_TYPES } from "../../../assets/constants/payment.constants";
import { initPayment } from "../../../assets/js/common";
import Expandable from "../../Expandable.vue";
export default {
  components: { Expandable },
  props: {
    id: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    paymentReferenceNo: {
      type: String,
      default: "",
    },
  },
  computed: {
    feeAmount() {
      return FEE_AMOUNTS.ARF;
    },
    isPaid() {
      return !!this.paymentReferenceNo;
    },
  },
  methods: {
    async paynow() {
      const vm = this;
      try {
        vm.$loader.show();
        let doc = {
          hospital_id: vm.id,
          payment_type: PAYMENT_TYPES.ARF,
          TransactionAmount: String(FEE_AMOUNTS.ARF),
          dml_indicator: "NH",
        };
        let { data } = await hospitalService.initPayment(doc);
        let { encryptedTrans, status, msg } = data;
        vm.$loader.hide();
        if (!status) {
          vm.$alert.show(msg);
          return;
        }
        // Redirect to SBI ePay gateway via form POST
        if (encryptedTrans) {
          initPayment(data);
        }
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style></style>
